import supabase from "artifact/supabase";
import connected from "standard/connected";
import define from "standard/define";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-status-activity")
class Profile extends HTMLElement {
  #statusActivity = "";

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @willPaint
  async [trait.fetch]() {
    const { data: activityCompleted } = await supabase
      .from("activity_completed")
      .select("*")
      .eq("user_id", this.dataset.user)
      .eq("activity_id", this.dataset.activity);

    const { data: statusActivity } = await supabase
      .from("activity_corrected")
      .select("*, activity_criterion!inner(*)")
      .eq("student_id", this.dataset.user)
      .eq("activity_criterion.activity_id", this.dataset.activity);

    if (activityCompleted.length > 0) {
      this.#statusActivity = `<span class='${style.pendente}'>Pendente</span>`;
    }

    if (statusActivity.length > 0) {
      this.#statusActivity = `<span class='${style.corrigida}'>Atividade corrigida</span>`;
    }

    return this;
  }

  @connected
  @paint
  [trait.template]() {
    return `
      ${this.#statusActivity}      
    `;
  }
}

export default Profile;
